import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PassConfirmDialog from "@/components/passes/dialogs/PassConfirmDialog";
import PassInfoDialog from "@/components/passes/dialogs/PassInfoDialog";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { SHOP_CHECKOUT_PAGE } from "@/settings/constant";
import { Divider, Icon } from "@bookips/sds";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import React, { Fragment, useCallback, useState } from "react";
import { getMemberships, PassCategory } from "src/api/membership";
import LoginDialog from "src/store/loginDialog";
import { usePurchasePassAction } from "./hooks/usePurchasePassAction";
import { PassItem } from "./PassItem";
//이용권 구매 리스트
export const PassList = (param)=>{
    let { data , handleSubscribeWarningDialog  } = param;
    const { push  } = useRouter();
    const { isLoggedIn  } = useAuthStore();
    const { openLoginDialog  } = LoginDialog();
    const [selectedPass, setSelectedPass] = useState(null);
    const [confirmDialogType, setConfirmDialogType] = useState(null);
    const purchase = usePurchasePassAction();
    const { data: userMembershipResponse , isLoading: isUserMembershipLoading  } = useQuery([
        "userMembership"
    ], ()=>getMemberships({}), {
        onError: (error)=>{
            ;
        },
        enabled: isLoggedIn,
        retry: 3
    });
    const handleOpenInfo = useCallback((pass)=>{
        setSelectedPass(pass);
    }, []);
    // 다이얼로그 '구매하기' 클릭 핸들러
    // - 일반: usePurchasePassAction (mixpanel + 미로그인 분기 + /checkout 푸시)
    // - 엑스퍼트: 보유 쏠북플러스(쏠플/구독권) 체크 후 차단(setExistSolvook) 또는 통과
    const handlePrimary = useCallback(()=>{
        if (!selectedPass) return;
        const { category , id , title , price  } = selectedPass;
        if (category === PassCategory.Expert) {
            mixpanelEvent("Purchase Button Clicked", {
                "Product Categories": category,
                "Product ID": id,
                "Product Title": title,
                "Product Price": price
            });
            if (!isLoggedIn) {
                setSelectedPass(null);
                openLoginDialog();
                return;
            }
            // 보유 이용권 조회가 끝나기 전 클릭은 보유 체크가 빈 배열로 평가돼 우회될 수 있음 → 차단
            if (isUserMembershipLoading) return;
            var _userMembershipResponse_unexpired;
            // unexpired 만 확인 (만료 이용권은 제외)
            const isExistSolvookPass = ((_userMembershipResponse_unexpired = userMembershipResponse === null || userMembershipResponse === void 0 ? void 0 : userMembershipResponse.unexpired) !== null && _userMembershipResponse_unexpired !== void 0 ? _userMembershipResponse_unexpired : []).some((item)=>item.productInfo.category.includes("solvookplus") || item.productInfo.category.includes("solvookplus-subscribe") || item.productInfo.categoryTitle === "쏠북 플러스" && item.productInfo.category.includes("ticket"));
            if (isExistSolvookPass) {
                setSelectedPass(null);
                setConfirmDialogType("existSolvookPlus");
                return;
            }
            push("".concat(SHOP_CHECKOUT_PAGE, "?id=").concat(id, "&orderType=pass"));
            setSelectedPass(null);
            return;
        }
        purchase(selectedPass);
        setSelectedPass(null);
    }, [
        selectedPass,
        isLoggedIn,
        isUserMembershipLoading,
        openLoginDialog,
        push,
        purchase,
        userMembershipResponse
    ]);
    if (data.subject === "") return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            data.products.map((group, index)=>{
                const { category , categoryTitle , categoryTitleDescription , categoryTitleDescriptionUrl , items  } = group;
                return /*#__PURE__*/ _jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ _jsx("h5", {
                                    className: "typo-h6 text-title mb-5",
                                    children: categoryTitle
                                }),
                                categoryTitleDescription && categoryTitleDescriptionUrl && /*#__PURE__*/ _jsxs("a", {
                                    className: "mb-3 flex gap-2 rounded-md bg-blue-50 p-3 hover:bg-blue-100",
                                    href: categoryTitleDescriptionUrl,
                                    onClick: ()=>{
                                        // mx-154 이용권 카테고리 설명 모듈 클릭 시
                                        mixpanelEvent("Pass Category Description Clicked", {
                                            "Pass Categories": categoryTitle,
                                            Url: categoryTitleDescriptionUrl
                                        });
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Icon.Check_2px, {
                                            className: "size-5 shrink-0 text-blue-400"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex w-full items-center justify-between gap-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "typo-body2 text-gray-700",
                                                    children: categoryTitleDescription
                                                }),
                                                /*#__PURE__*/ _jsx(Icon.ArrowRight_2px, {
                                                    className: "size-4 shrink-0 text-gray-500"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: "flex flex-col gap-3",
                                    children: items === null || items === void 0 ? void 0 : items.map((pass, index)=>/*#__PURE__*/ _jsx(PassItem, {
                                            pass: pass,
                                            handleSubscribeWarningDialog: handleSubscribeWarningDialog,
                                            onOpenInfo: handleOpenInfo
                                        }, index))
                                })
                            ]
                        }),
                        index + 1 < data.products.length && /*#__PURE__*/ _jsx(Divider, {})
                    ]
                }, index);
            }),
            selectedPass && /*#__PURE__*/ _jsx(PassInfoDialog, {
                isOpen: true,
                pass: selectedPass,
                mode: "purchase",
                position: "이용권 구매",
                onPrimary: handlePrimary,
                onClose: ()=>setSelectedPass(null)
            }),
            /*#__PURE__*/ _jsx(PassConfirmDialog, {
                type: confirmDialogType,
                onClose: ()=>setConfirmDialogType(null)
            })
        ]
    });
};
